<template>
  <b-modal 
    v-bind:visible="value"
    centered
    size="xl" 
    hide-header-close
    no-close-on-backdrop
    scrollable
    
    title="Confirmation"
  >
    <div class="confirmMessage">
      You are about to submit the following to Brighton Cromwell. Please confirm its accuracy.   
        <br />
      Click "Cancel" to make any changes.
    </div>

    <slot></slot>
    
    <template v-slot:modal-footer>
       
          <b-button
            variant="secondary"
            class="float-right"
            @click="$emit('input')"
          >
            Cancel
          </b-button>
          <b-button
            variant="success"
            class="float-right"
            @click="$emit('ok')"
          >
            Confirm
          </b-button>
       
      </template>

  </b-modal>
</template>

<script>

export default {
  name: 'confirmation_dialog',
  props: ['value']
}
</script>

<style scoped>
.confirmMessage {
  margin-left: 20px;
  margin-bottom: 20px; 
  font-size: 90%;
  font-weight: bold;
  color: #888888;
}
</style>